// src/utils/cookieConsent.js
// Unico punto di verita' per il consenso cookie: chiave di salvataggio,
// eventi e, soprattutto, A QUALE CATEGORIA appartiene ogni strumento.
// Se la Cookie Policy cambia categoria a uno strumento, si modifica SOLO
// la mappa STRUMENTI qui sotto: banner, caricamento script e revoca si
// adeguano da soli.

export const COOKIE_CONSENT_KEY = 'mima_cookie_consent';
// Scatta quando l'utente salva una scelta (letto anche da Floatingcta.js)
export const COOKIE_CONSENT_EVENT = 'mima-cookie-consent-updated';
// Scatta per riaprire il pannello preferenze (link "Gestisci i cookie")
export const OPEN_PREFERENCES_EVENT = 'mima-open-cookie-preferences';

// Categorie mostrate nel banner. 'required' non e' disattivabile.
export const CATEGORIE = {
    required: 'Cookie tecnici (necessari)',
    preferences: 'Cookie di preferenze (es. chat di supporto)',
    analytics: 'Cookie analitici',
    social: 'Cookie social media',
    ads: 'Cookie pubblicitari',
};

// Strumento -> categoria della Cookie Policy.
// 'required' = caricato sempre, senza chiedere consenso.
export const STRUMENTI = {
    crisp: 'required',        // chat di supporto (Crisp IM SAS)
    contentsquare: 'analytics',
    metaPixel: 'ads',
};

// Categorie che hanno almeno uno strumento: le altre non vengono mostrate
// nel banner (inutile chiedere consenso per qualcosa che non usiamo).
export const categorieInUso = () =>
    Object.keys(CATEGORIE).filter(
        (c) => c !== 'required' && Object.values(STRUMENTI).includes(c)
    );

export const leggiConsenso = () => {
    try {
        const raw = localStorage.getItem(COOKIE_CONSENT_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
};

// true se lo strumento puo' essere attivato con le preferenze date
export const strumentoConsentito = (strumento, prefs) => {
    const categoria = STRUMENTI[strumento];
    if (categoria === 'required') return true;
    return !!(prefs && prefs[categoria]);
};

export const apriPreferenzeCookie = () => {
    window.dispatchEvent(new Event(OPEN_PREFERENCES_EVENT));
};
